export default __webpack_public_path__ + "55102301738de7896b68cc60f0ab464b.png";